<template>
  <section
    :aria-expanded="!closed"
    :aria-label="ariaLabel"
    :data-collapsible-block-name="blockName"
    >
    <button
      :aria-expanded="!closed"
      class="link/focus"
      type="button"
      @click.prevent="toggle"
      >
      <span v-html="svgContent" />
    </button>
    <div
      class="layout/margin:top:page:0.5"
      :class="{ 'layout/none': closed }"
      >
      <slot />
    </div>
  </section>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';

  export default {
    props: {
      ariaLabel: { type: String, required: true },
      blockName: { type: String, required: false, default: 'Collapsible block' },
      toggleTextOpen: { type: String, required: false, default: 'Open' },
      toggleTextClosed: { type: String, required: false, default: 'Close' },
    },

    data() {
      return {
        closed: true,
      };
    },

    computed: {
      toggleText() {
        return this.closed ? this.toggleTextOpen : this.toggleTextClosed;
      },
      svgContent() {
        return addSvgToEnd(this.toggleText, 'typography', 'icon__caret--16--stroke.svg', this.svgClass);
      },
      svgClass() {
        return this.closed ? 'typography/icon:after:90deg' : 'typography/icon:after:270deg';
      },
    },

    methods: {
      toggle() {
        this.closed = !this.closed;
      },
    }
  };
</script>
